/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class MarketExchangeDialog extends SiteEntityDialog<MarketExchangeRow, any> {
        protected getFormKey() { return MarketExchangeForm.formKey; }
        protected getIdProperty() { return MarketExchangeRow.idProperty; }
        protected getLocalTextPrefix() { return MarketExchangeRow.localTextPrefix; }
        protected getNameProperty() { return MarketExchangeRow.nameProperty; }
        protected getService() { return MarketExchangeService.baseUrl; }

        protected form = new MarketExchangeForm(this.idPrefix);

    }
}